import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import CodeBlock from './components/CodeBlock';
var CodeBlockWithTheme = withTheme(CodeBlock);
var emptyTheme = {};

var ThemeCodeBlock = function ThemeCodeBlock(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: emptyTheme
  }, /*#__PURE__*/React.createElement(CodeBlockWithTheme, props));
};

export default ThemeCodeBlock;